export default "__VITE_ASSET__DH6ZEZV3__"